// @ts-ignore
import Vue from 'vue';
// @ts-ignore
import { Component, Prop, Watch } from "vue-property-decorator";

//Components
import WithRender from 'Components/WorkbenchLanding/workbench-landing.html';
import { IfcWorkbenchPageData } from 'Interfaces/ifcWorkbenchPageData';
import WorkbenchCard from "Components/Shared/WorkbenchCard/WorkbenchCard";
import ApiService from "../../services/apiService";

@WithRender
@Component({
	components: {
		WorkbenchCard
	}
})

export default class WorkbenchLanding extends Vue {
	pageData = JSON.parse(document.querySelector('.js-page-data').getAttribute('data-page-data')) as IfcWorkbenchPageData;
	translations = JSON.parse(document.querySelector('.js-page-data').getAttribute('data-translations'));
	selectedLocation:any = this.pageData.Locations[0].UrlName;
	selectedCategory:any = this.pageData.Categories[0].UrlName;
	showAll:any = this.pageData.ShowAll;
	loadingResults:boolean = false;

	$refs!: {
		loadMoreButton: HTMLElement,
		resultsWrap: HTMLElement
	};

	created() {
		let vm = this;

		const urlParams = new URLSearchParams(window.location.search);

		//check if urlParms exits when the app is created if so set the values
		if(urlParams.has('category') || urlParams.has('location') || urlParams.has('showAll')) {
			let categoryValue = urlParams.has('category') ? (urlParams.get('category') ? urlParams.get('category') : null) : (vm.selectedCategory ? vm.selectedCategory : null);
			let locationValue = urlParams.has('location') ? (urlParams.get('location') ? urlParams.get('location') : null) : (vm.selectedLocation ? vm.selectedLocation : null);
			let showAllValue = urlParams.has('showAll') ? urlParams.get('showAll') : vm.showAll;
			vm.selectedCategory = categoryValue;
			vm.selectedLocation = locationValue;
			vm.showAll = showAllValue;

			window.scrollTo({
				top: document.getElementById('workbenchLanding').offsetTop,
				behavior:'smooth'
			});
		}
	}

	filterRequest(showAllTrue?, paramValues?) {
		let vm = this;
		vm.loadingResults = true;

		if(showAllTrue === true) {
			vm.showAll = true;
		} else {
			vm.showAll = false;
		}

		let data = {
			category: paramValues ? paramValues[0] : (vm.selectedCategory ? vm.selectedCategory : ''),
			location: paramValues ? paramValues[1] : (vm.selectedLocation ? vm.selectedLocation : ''),
			showAll: paramValues ? paramValues[2] : vm.showAll
		};

		ApiService.fetchWorkbenchProjectData(vm.pageData.BaseUrl, data).then(response => {
			vm.pageData = response;
			history.replaceState(null, 'The Creator\'s Corner™ | National Hardware', `${vm.pageData.BaseUrl}?category=${data.category}&location=${data.location}&showAll=${data.showAll}`);

			if(!vm.selectedLocation) {
				vm.selectedLocation = vm.pageData.Locations[0].UrlName;
			}
			if(!vm.selectedCategory) {
				vm.selectedCategory = vm.pageData.Categories[0].UrlName;
			}

			setTimeout(() => {
				vm.loadingResults = false;
			}, 1000);
		}).catch(function() {
			setTimeout(() => {
				vm.loadingResults = false;
			}, 1000);
		});
	}

	loadMoreResults(e){
		let vm = this;
		vm.filterRequest(true);
	}
}
